// Module
var code = "<react-component name=\"EditContactForms\"></react-component>\n";
// Exports
module.exports = code;